// extracted by mini-css-extract-plugin
module.exports = {"VerifiedBadge":"VerifiedBadge_VerifiedBadge__VlBzF"};